if(!customElements.get('custom-collection-grid')){
    class CustomCollectionGrid extends HTMLElement {
        constructor(){
            super();

            this.swiperContainer = this.querySelector('.swiper-container');
            if(this.swiperContainer){
                this.initSwiper();
            }
        }

        initSwiper(){
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView) || 4;
            var mobileColumns = parseInt(this.swiperContainer.dataset.mobileColumns) || 0;
            var mobileSlidesPerView = mobileColumns > 0
                ? (numPerView < mobileColumns? numPerView : mobileColumns)
                : (numPerView < 2? numPerView : 2);

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: { slidesPerView: mobileSlidesPerView, spaceBetween: 10 },
                    576: { slidesPerView: numPerView < 3? numPerView : 3 },
                    992: { slidesPerView: numPerView }
                },
                observer: true,
                observeSlideChildren: true
            }

            if(this.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination')
                }
            }

            if(this.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                }
            }

            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            if(swiperSettings.autoplay){
                this.swiperContainer.addEventListener('mouseenter', () => {
                    this.swiper.autoplay.stop();
                });
                this.swiperContainer.addEventListener('mouseleave', () => {
                    this.swiper.autoplay.start();
                });
            }
        }

        refresh(){
            if(this.swiperContainer){
                this.initSwiper();
            }
        }
    }

    customElements.define('custom-collection-grid', CustomCollectionGrid);
}
